<template>
<!--    <v-app>-->
        <v-container>
            <v-layout row>
                <v-flex xs12 sm12 md12 lg12 px-2>
                    <h1 style="text-align: center;"><strong>Terms of Service</strong></h1><br>
                    <h3 style="text-align: center;">
                        Magnify Insights Terms of Services [June 2017]
                    </h3>
                    <br>
                    <h2 class="privacy__title">
                        I. About Magnify Insights
                    </h2><br>
                    <p class="para">
                        The Services are provided by Magnify Pte Ltd, registered under Accounting and Corporate
                        Regulatory Authority (ACRA) of Singapore with its main office located 140 Paya Lebar road #10-09
                        AZ @ Paya Lebar (409015).
                    </p><br>
                    <h2 class="privacy__title">
                        II. Scope of the ToS
                    </h2><br>
                    <p class="para">
                        These ToS govern any and all uses of the Services. They are provided to Users at the time of the
                        Services’ subscription and are available at any time. Users acknowledge having read and
                        understood the ToS and hereby accept to be bound by them. The ToS shall prevail over any other
                        contractual document issued by Users. Users may have concluded a service contract with
                        Bindez Pte. Ltd. In case of conflict between them, the service contract prevails over the ToS.
                        Bindez Pte. Ltd reserves the right, at its discretion, to modify the ToS at any time by posting
                        a notice through the Services, or by sending Users a notice via email. Users shall be
                        responsible for reviewing and becoming familiar with any such modifications. Use of the Services
                        following such notification constitutes Users' acceptance of the modified ToS.
                    </p><br>
                    <h2 class="privacy__title">
                        III. Definitions
                    </h2><br>
                    <p class="para">
                        The capitalized terms shall have the definition given to them below or in the ToS:<br>
                        Account means a valid account giving access to the Services;<br>
                        Administration Page means the private page accessible from the Account and displaying Users'
                        settings;<br>
                        Alert(s) or Monitor(s) mean(s) the request(s) entered via the Services by Users including or
                        excluding one or several keyword(s) determined by them. The Monitors direct to the Mentions;<br>
                        Basic Plan means one of the several options offered by Magnify Insights to Users for subscribing
                        to the Services. Users may freely subscribe to the Basic Plan, which contains the following
                        limitations: number of Users per Account and number of Monitors and Mentions per month per
                        Account;<br>
                        Collaborator(s) mean(s) Users&rsquo; employees or contractors expressly authorized by Users to
                        access and use the Services on their behalf. Collaborators agree to be bound by the ToS;
                    </p>
                    <p class="para">
                        Fees mean the fees for the Services applicable only for Paid Plans;
                    </p>
                    <br>
                    <p class="para">
                        Free Users mean Users subscribing to the Basic Plan;
                    </p>
                    <br>
                    <p class="para">
                        Filter(s) mean(s) the automatic filter(s) through an algorithm based on Users&rsquo; selection
                        and developed by Magnify Insights. Filters may be activated under Users&rsquo; control and
                        responsibility;
                    </p>
                    <br>
                    <p class="para">
                        License means the license given by Magnify Insights to Users for using the Services;
                    </p>
                    <br>
                    <p class="para">
                        Mentions mean the real-time results displaying Third-Party Content from Third-Party Websites as
                        a result of the Monitors. The Mentions requested by Users may temporarily reproduce Third-Party
                        Content which is carried out entirely in the context of the implementation of a technological
                        process. All reproductions of Third-Party Content are necessary for implementing said
                        technological process;
                    </p>
                    <br>
                    <p class="para">
                        Paid Plans mean charged Plans proposed to Users (premium, business or enterprise);
                    </p>
                    <br>
                    <p class="para">
                        Paid Users mean Users subscribing to a Paid Plan;</p>
                    <br>
                    <p class="para">
                        Party(ies) mean(s) Magnify Insights and/or Users;</p>
                    <br>
                    <p class="para">
                        Personal Data means any data relating to a living individual who is or may be identified;
                    </p>
                    <br>
                    <p class="para">
                        Plan means Basic and/or Paid Plans;
                    </p>
                    <br>
                    <p class="para">
                        Privacy Policy means the document written by Magnify Insights explaining how it handles Users&rsquo;
                        personal data and defined Users&rsquo; rights related to their personal data (
                        <router-link to="/privacy-policy" style="text-decoration: none;" target="_blank">Privacy Policy</router-link>);
                    </p>
                    <br>
                    <p class="para">
                        Quota means a limitation on the number of Mentions, Monitors or Users depending on the Plan
                        chosen by Users;
                    </p>
                    <br>
                    <p class="para">
                        Search Engine means the search engine developed and provided by Magnify Insights through the
                        Services;
                    </p>
                    <br>
                    <p class="para">
                        Services mean the content neutral tool provided to Users under their sole responsibility by
                        Magnify Insights including the Search Engine in order to facilitate Users&rsquo; online
                        researches. The Services may be accessed as a Software as a Service (SaaS), via a downloadable
                        software program or via an API;
                    </p>
                    <br>
                    <p class="para">
                        Sources mean the Third-Party Websites&rsquo; classification via the Services: Facebook&reg;,
                        Twitter&reg;, News, Blogs, Videos, Forums and Images;
                    </p>
                    <br>
                    <p class="para">
                        Term means the monthly or yearly term chosen by Users during which they use the Services;
                    </p>
                    <br>
                    <p class="para">
                        Third-Party Content(s) mean(s) the third-party content freely accessible in whole or in part
                        from various Third-Party Websites, including but not limited to texts, graphics, news articles,
                        photographs, images, illustrations, video clips, advertising and trademarks, which may be
                        protected by copyright or private rights. The Third-Party Content is displayed by Bindez
                        Insights upon request of Users under Users&rsquo; control;
                    </p>
                    <br>
                    <p class="para">
                        Third-Party Website(s) mean(s) the third-party website created and administered by a third-party
                        and making available the Third-Party Content;&nbsp;
                    </p>
                    <br>
                    <p class="para">
                        ToS mean these terms of services;</p>
                    <br>
                    <p class="para">
                        Users mean any persons or entities using the Services and opening an Account. "GTCS" refer to
                        these general terms and conditions of sale;
                    </p>
                    <br>
                    <p class="para">
                        <strong>"Client"</strong> refers to the legal or natural person having subscribed to the
                        internet media watch solution Service;
                    </p>
                    <br>
                    <p class="para">
                        <strong>"Special Terms and Conditions"</strong> refer to the specific terms and conditions
                        applicable to the Client's order and relating to the Service, price, term, subscription start
                        date, subscription renewal date and payment terms;
                    </p>
                    <br>
                    <p class="para">
                        <strong>"Agreement"</strong> refers to the GTCS and the Special Terms and Conditions;
                    </p>
                    <br>
                    <p class="para">
                        <strong>"Data"</strong> refers to the Client's digital data, whether personal or not, collected,
                        processed and/or shared between the Client and the Service Provider and which are likely to be
                        intended for third parties, as part of the Service access and user rights;
                    </p>
                    <br>
                    <p class="para">
                        <strong>"Intellectual Property Right"</strong> refers to any patent, copyright, moral right,
                        trade name, brand, trade secret, as well as any request to obtain one of the above rights,
                        Internet domain names, logos, creations, slogans, and intangible elements of a similar nature,
                        programs, software or applications, physical or intangible proprietary information, namely
                        proprietary processes, formulas, algorithms, or any other intellectual property right, whether
                        the latter are registered or not and whether or not they were created before or after the
                        effective date of the Agreement;
                    </p>
                    <br>
                    <p class="para">
                        <strong>"Terms of Service"</strong> refer to the "Terms of Service" and "Privacy Policy"
                        available at the following addresses:
                        <router-link to="/terms_and_conditions" style="text-decoration: none" target="_blank">Terms
                            of Service</router-link> and <router-link to="/privacy-policy" target="_blank">Privacy
                        Policy</router-link>
                        They form an integral part of the Agreement, as regularly updated. In the event of contradiction
                        between the Agreement and the Terms of Service, the stipulations of the Agreement shall prevail.
                    </p>
                    <br>
                    <p class="para">
                        <strong>"Party or Parties"</strong> refer individually to the Service Provider or the Client and
                        jointly to the Service Provider and the Client.
                    </p>
                    <br>
                    <p class="para">
                        <strong>"Service Provider"</strong> refers to Bindez Pte Ltd, registered under Accounting and
                        Corporate Regulatory Authority (ACRA) of Singapore with its main office located 140 Paya Lebar
                        road #10-09 AZ @ Paya Lebar (409015);
                    </p>
                    <br>
                    <p class="para">
                        <strong>"Service"</strong> refers to the Magnify Insights social media listening application
                        solution, hosted on the servers designated by the Service Provider which can be remotely run by
                        the Client in particular via a dedicated or SaaS application programming interface (API);
                    </p>
                    <br>
                    <p class="para">
                        <strong>"Consulting Services"</strong> refer to the services involving consulting, development
                        where necessary, configuration, set-up assistance provided by the Service Provider to enable the
                        Client to use the Service;
                    </p>
                    <p class="para">
                        <strong>"Site"</strong> refers to the web pages associated with the electronic functions
                        described in the Service Documentation accessible by and configured for and/or by the Client.
                    </p>
                    <h2 class="privacy__title">IV. Description of the Services</h2><br>
                    <h2 class="privacy__sub-title">
                        1. Monitoring Third-Party Websites by creating Monitors
                    </h2>
                    <p class="para">
                        Users may use the Services to monitor Third-Party Content accessible through Third-Party
                        Websites by selecting the Monitor(s) of their choosing.
                    </p>
                    <br>
                    <p class="para">
                        The Mentions are accessible from the Users&rsquo; Account interface and are referenced
                        automatically and in real time without any control of Magnify Insights.
                    </p>
                    <br>
                    <p class="para">
                        The Mentions are classified according to their date of online publication and according to
                        Third-Party Websites&rsquo; Sources: Web, Facebook&reg;, Twitter&reg;, News, Blogs, Videos,
                        Forums, and Images.
                    </p>
                    <h2 class="privacy__sub-title">
                        2. Filtering and assessing Third-Party Content
                    </h2><br>
                    <p class="para">
                        Each Mention contains:
                    </p>
                    <ul class="fact-list--style">
                        <li>
                            a logo related to the level of priority of the Third-Party Websites based on their sharing;
                        </li>
                        <li>
                            a tone (positive, negative or neutral) of Third-Party Content automatically generated and
                            based on the selection of other Users. By default, the Tone is neutral but may be changed by
                            Users and will be visible by others if the Mention is shared.
                        </li>
                    </ul>
                    <br>
                    <p class="para">
                        Users may activate one or several Filters under their sole control and responsibility:
                    </p>
                    <ul class="fact-list--style">
                        <li>
                            "blocked sites" to automatically block Third-Party Websites&rsquo; selected by Users;
                        </li>
                        <li>
                            "priority inbox" to automatically identify the Mentions coming from influential Third-Party
                            Websites and important Sources;
                        </li>
                        <li>
                            "anti-noise" to automatically remove the Mentions similar to those previously deleted by
                            Users;
                        </li>
                        <li>
                            "geolocalisation" to automatically locate Monitors&rsquo; areas.
                        </li>
                    </ul>
                    <br>
                    <h2 class="privacy__sub-title">
                        3. Sharing Monitors and Third-Party Content and uploading Monitors from other services
                    </h2><br>
                    <p class="para">
                        Users may share the Monitors, the Mentions and the Third-Party Content with anyone regardless of
                        whether they have an Account.&nbsp;
                    </p>
                    <p class="para">
                        Users share the Monitors under their sole responsibility.&nbsp;
                    </p>
                    <p class="para">
                        Users may upload Monitors created from other compatible services provided that such upload does
                        not violate the other services&rsquo; terms and conditions.&nbsp;
                    </p>
                    <p class="para">
                        Users shall obtain all authorization to upload Monitors from other compatible
                        Services.
                    </p>
                    <h2 class="privacy__sub-title">
                        4. Accessing and Commenting Third-Party Content
                    </h2><br>
                    <p class="para">
                        Users may access and comment Third-Party Content after being redirected to Third-Party Websites
                        by clicking on the URL link.
                    </p>
                    <p class="para">
                        Users may connect a social account to an Monitor and may react to any Mention without having to
                        leave the Services.
                    </p>
                    <h2 class="privacy__sub-title">
                        5. Activity feed and analyzing statistics
                    </h2><br>
                    <p class="para">
                        Depending on the Paid Plan, Users may assign tasks to Collaborators such as reading, retweeting
                        or reposting a Mention and may receive statistics.
                    </p>
                    <h2 class="privacy__sub-title">6. Archiving Mentions</h2><br>
                    <p class="para">
                        Depending on the Plan, Users may archive one or several Mention(s). The archive will contain a
                        URL link to the Third-Party Websites reproducing the Third-Party Content requested by Users.
                    </p>
                    <h2 class="privacy__title">
                        V. Accessing the Services by creating an Account
                    </h2><br>
                    <p class="para">
                        To access and use the Services, Users must be legally capable of entering into a binding
                        agreement and abide by all applicable law (Singapore and/or foreign).
                    </p>
                    <p class="para">
                        To use the Services, Users must create an Account and provide the following information:
                    </p>
                    <ul class="fact-list--style">
                        <li>
                            Name;
                        </li>
                        <li>
                            Email address;
                        </li>
                        <li>
                            Password;
                        </li>
                        <li>
                            When relevant: company name, phone number, number of employees.
                        </li>
                    </ul>
                    <p class="para">
                        The email address must remain valid as long as the associated Account remains active. Users are
                        responsible to update said email address if necessary.
                    </p>
                    <p class="para">
                        Users’ passwords are strictly personal and confidential and Users shall not share it with anyone
                        (except for their Collaborators and depending on the Paid Plans).
                    </p>
                    <p class="para">
                        If Collaborators create Accounts on behalf of a User, they warrant to be authorized to grant all
                        permissions provided in the ToS and to bind the User to the ToS, and that they agree to the ToS
                        on the User' behalf.
                    </p>
                    <p class="para">
                        Users may under their sole responsibility upload an avatar (photograph, image, logo, etc.)
                        associated with their Account.
                    </p>
                    <h2 class="privacy__title">
                        VI. Magnify Insights’ duties
                    </h2><br>
                    <p class="para">
                        Magnify Insights shall provide Users (and as the case may be the Collaborators) with the Services
                        according to the applicable Plan.
                    </p>
                    <p class="para">
                        Subject to the ToS and provided that Users have paid all applicable Fees, Magnify Insights grants
                        to Users a limited, non-exclusive, non-transferable and revocable License to use the Services.
                    </p>
                    <p class="para">
                        Magnify Insights shall provide Paid Users with tools enabling them to upload their Monitors
                        created from other compatible services, to share the Monitors, the Third-Party Content and
                        Websites, to access and comment Third- Party Content, to assign tasks, perform statistics, and
                        archive the Mentions.
                    </p>
                    <h2 class="privacy__title">
                        VII. Users’ duties
                    </h2><br>
                    <h2 class="privacy__sub-title">
                        1. Using the Services
                    </h2><br>
                    <p class="para">
                        As a condition for accessing and using the Services, Users agree:
                    </p>
                    <ul class="fact-list--style">
                        <li>to always provide truthful and actual personal data and to update them as needed so that
                            they remain true, complete and accurate;
                        </li>
                        <li>to use the Services pursuant to their destination;</li>
                        <li>if applicable, to select the Paid Plans applicable to their location;</li>
                        <li>to respect the third-parties’ rights and, more generally, all applicable laws and
                            regulations relevant to the use of the Services;
                        </li>
                        <li>to use Third-Party Content and Third-Party Websites in accordance with the ToS and with any
                            applicable legal or contractual restriction;
                        </li>
                        <li>not to engage in any conduct that would interrupt, destroy, limit or more generally harm the
                            Services or enable Users to gain unauthorized access to the Services, including by using
                            viruses, malicious code, programs or files;
                        </li>
                        <li>not to copy or sell in whole or in part the Services;</li>
                        <li>not to create more than one Account, nor to create a new Account further to the cancellation
                            by Magnify Insights.
                        </li>
                    </ul>
                    <br>
                    <h2 class="privacy__sub-title">
                        2. Payment
                    </h2><br>
                    <p class="para">
                        Paid Users shall make payments to Magnify Insights pursuant to article VIII of the ToS.
                    </p>
                    <h2 class="privacy__title">
                        VIII. Financial terms and conditions
                    </h2><br>
                    <p class="para">
                        Paid Plans require the payment of Fees according to the applicable fees schedule.
                    </p>
                    <p class="para">
                        Applicable Fees for the use of the Services may differ and may be displayed in different
                        currencies depending on the Users’ location (with taxes, if applicable).
                    </p>
                    <p class="para">
                        Users may pay Fees by credit card or by wire transfer.
                    </p>
                    <p class="para">
                        Users may at any time decide to change their Plan. Any change toward a lower Plan shall be
                        applicable at the end of the current Term, whereas any upgrade shall be applicable immediately.
                    </p>
                    <p class="para">
                        Magnify Insights reserves the right to update its fees schedule and to create new charges at any
                        time, upon one (1) month prior notice to Users, which may be sent by email or posted on the
                        Site. The new Fees schedule will apply only after the renewal Term.
                    </p>
                    <p class="para">
                        Invoices are sent to Paid Users by email and remain accessible from their Account at any time.
                    </p>
                    <h2 class="privacy__title">
                        IX. Intellectual Property
                    </h2>
                    <p class="para">5.1 The Site and Service, as well as all their components and contents, including
                        the dedicated API, are protected by intellectual property rights and remain the exclusive
                        property of the Service Provider and its partners. Any reproduction, editing or exploitation
                        whatsoever of the Intellectual Property Rights is explicitly prohibited.</p>
                    <p class="para">Subject to full payment of the price, the Service Provider grants the Client a
                        non-exclusive, named, personal and temporary right to access and use the Service.</p>
                    <p class="para">The Service Provider explicitly reserves the exclusive right to adapt, arrange
                        and/or modify the Service, Site and/or dedicated API.
                    </p>
                    <p class="para">Any Intellectual Property Right related to the outcome of the services performed by
                        the Service Provider under the Agreement, as well as any related documentation (jointly referred
                        to as "Outcome of Works") are and shall remain the exclusive property of the Service Provider or
                        shall be assigned to the latter by the Client, on the understanding that the assignment shall
                        take place from the Creation of the Outcome of the Works and be valid worldwide, for the
                        validity period of the rights.
                    </p>
                    <p class="para">5.2 The Client states that it has previously read the Terms of Service, the
                        Documentation and the technical and functional specifications of the Service and state that they
                        meet its needs and expectations.
                    </p>
                    <p class="para">The Client undertakes to (i) only use the information contained in the Documentation
                        for its own needs and solely for the purposes of the Agreement, (ii) comply with the terms and
                        restrictions of use set out in the Agreement, as well as in the Documentation and to (iii) not
                        hinder or disrupt the execution of the Service. The Client vouches for compliance with the
                        foregoing by its Users
                    </p>
                    <h2 class="privacy__title">
                        X. Liability, disclaimer and warranties
                    </h2><br>
                    <h2 class="privacy__sub-title">
                        1. Magnify Insights’ liability and warranties applicable for Paid Plans
                    </h2><br>
                    <p class="para">
                        Magnify Insights warrants that:

                    </p>
                    <ul class="fact-list--style">
                        <li>Users shall be able to monitor Third-Party Content by using the Services and to create
                            Monitors in order to generate Mentions;
                        </li>
                        <li>it will not change User’s Filters and more generally Users’ settings regarding to the
                            Services without notice;
                        </li>
                        <li>it will execute Users’ requests for accessing and sharing Third-Party Content and conducting
                            analysis;
                        </li>
                        <li>it will take all reasonable measures to maintain the confidentiality of Users’ information.
                        </li>
                    </ul>
                    <br>
                    <h2 class="privacy__sub-title">2. Magnify Insights’ liability and warranties applicable for Basic
                        Plan
                    </h2><br>
                    <p class="para">As consideration for the providing of the Services for free, Magnify Insights gives
                        no warranty, whether implied or express, to Free Users.
                    </p>
                    <p class="para">Magnify Insights may not be held liable for interruption of the Services.
                    </p>
                    <h2 class="privacy__sub-title">3. Magnify Insights’ disclaimer for Paid Plans and Basic Plan
                    </h2><br>
                    <p class="para">
                        TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE SERVICES AS PROVIDED BY BINDEZ INSIGHTS
                        ARE PROVIDED AND LICENSED "AS IS" WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESSED OR IMPLIED.
                        BINDEZ INSIGHTS DOES NOT GUARANTEE THAT THE USE OF THE SERVICES WILL BE UNINTERRUPTED OR ERROR
                        FREE.
                    </p>
                    <p class="para">The Services may be changed, amended and/or otherwise altered at any time in Magnify
                        Insights’ sole discretion.
                    </p>
                    <p class="para">Magnify Insights does not exercise any control over Third-Party Content and Websites
                        and has no control over them. Similarly, Magnify Insights does not control links to Third-Party
                        Websites. Third-Party Content is provided to Users "as is" to facilitate their web browsing.
                    </p>
                    <p class="para">Magnify Insights takes no responsibility and assumes no liability for any Third-Party
                        Content that Users post or transmit using the Services. Users understand and agree that they may
                        be exposed to Third-Party Content that is inaccurate, objectionable, inappropriate for children,
                        or otherwise unsuited to their purpose.
                    </p>
                    <p class="para">If Users access any Third-Party Websites or Third-Party Content from the Services,
                        they do so at their own risk and agree that Magnify Insights will have no liability arising from
                        their use of or access to any Third-Party Websites or Third-Party Content.
                    </p>
                    <h2 class="privacy__sub-title">
                        4. Users’ liability, disclaimer and warranties applicable for Paid Plans and Basic Plan
                    </h2><br>
                    <p class="para">
                        Users agree that:
                    </p>
                    <ul class="fact-list--style">
                        <li>Third-Party Content and links to Third-Party Websites are reproduced upon their request;
                        </li>
                        <li>Magnify Insights does not exercise any control over and does not pre-screen Third-Party
                            Content and may not be held liable for their communication to the public;
                        </li>
                        <li>Magnify Insights may not be held liable for any damages or loss arising from or connected
                            with the use of or the reliance on the Third-Party Contents, goods, or services available on
                            the Third-Party Websites;
                        </li>
                        <li>Magnify Insights may not be held liable with respect to Third-Party Content or Third-Party
                            Websites and Users undertake to directly and exclusively contact the appropriate third-party
                            with any claim or request they may have;
                        </li>
                        <li>They use the Services at their own risk which are being provided to them on an "as is" and
                            "as available" basis.
                        </li>
                    </ul>
                    <br>
                    <p class="para">Users shall be responsible for:</p>
                    <ul class="fact-list--style">
                        <li>their access, use and selection of the Services, including by their Collaborators;
                        </li>
                        <li>the selection of the Monitors and the reproduction of Third-Party Content in the Mentions;
                        </li>
                        <li>obtaining and maintaining any equipment needed to access and use the Services;
                        </li>
                        <li>ensuring that such equipment is compatible with the Services;
                        </li>
                        <li>sharing and commenting on Third-Party Content and accessing to Third-Party Websites.
                        </li>
                    </ul>
                    <br>
                    <p class="para">
                        Users are solely responsible for their connection to the internet and all costs incurred. Access
                        to the Services may be available through software programs downloaded to Users’ terminal. Users
                        agree that Magnify Insights may automatically upgrade those software programs, and the ToS will
                        apply to such upgrades.

                    </p>
                    <p class="para">
                        Users shall indemnify and hold Magnify Insights (and its affiliates and subsidiaries, and its and
                        their respective officers, directors, employees, agents) harmless from any claim or demand,
                        including reasonable legal fees, made by any third-party due to or arising out of their breach
                        of the ToS, their improper use of the Services or their breach of any law or the rights of a
                        third-party.

                    </p>
                    <h2 class="privacy__title">
                        XI. Indemnification

                    </h2><br>
                    <p class="para">
                        IN NO EVENT SHALL EITHER PARTY BE LIABLE TO THE OTHER PARTY UNDER THE TOS FOR ANY INDIRECT
                        DAMAGES, INCLUDING WITHOUT LIMITATION DAMAGES FOR LOST DATA OR LOST PROFITS.

                    </p>
                    <h2 class="privacy__title">
                        XII.Term and termination
                    </h2><br>
                    <p class="para">
                        The ToS are entered into monthly or yearly Term and those Terms are renewed automatically.

                    </p>
                    <p class="para">
                        Each of the Parties may terminate at any time directly from the Administration Page.

                    </p>
                    <p class="para">Any cancellation of payment for the Services will take place at the next renewal
                        Term: full month or year are charged for the month or year which Users discontinued service. No
                        refunds or credits can be made for partial use of the Services.
                    </p>
                    <p class="para">Upon termination of these ToS, regardless of the reason, Users shall not be able to
                        access the Services and the License shall be automatically terminated.
                    </p>
                    <p class="para">Articles IX, X, XI, XII and XIII will survive the expiration or termination of the
                        ToS.
                    </p>
                    <h2 class="privacy__title">
                        XIII. Miscellaneous
                    </h2><br>
                    <h2 class="privacy__sub-title">1. Contact
                    </h2><br>
                    <p class="para">
                        For any request, Users may write to Magnify Insights: <a style="text-decoration:none;" href="mailto:support@bindez.com">support@bindez.com</a>

                    </p>
                    <p class="para">
                        Users may report abuse, harassment, inappropriate Third-Party Content, privacy complaints or
                        more generally any violation of the law by a third-party by sending a notification to <a style="text-decoration:none;" href="mailto:support@bindez.com">support@bindez.com</a>.
                    </p>
                    <ul class="fact-list--style">
                        <li>Date of notification;
                        </li>
                        <li>Name, first name, employment, address, nationality, date and place of birth (and for a
                            company: form, name, address and representative);
                        </li>
                        <li>A description of the fact and their location;</li>
                        <li>The reason of notification (with legal explanation);
                        </li>
                        <li>A copy of the letter sent to the Third-Party Content’s author or the justification that this
                            author cannot be contacted.
                        </li>
                    </ul>
                    <br>
                    <h2 class="privacy__sub-title">2. Force Majeure
                    </h2><br>
                    <p class="para">11.1 The Parties shall not be liable for the non-fulfilment of their obligations in
                        case of the occurrence of force majeure event as defined by French case law making it impossible
                        to perform the Agreement.
                    </p>
                    <p class="para">
                        11.2 In such a case, the Agreement shall be suspended until the force majeure event ceases to
                        apply. The Parties shall meet to discuss the conditions for adaptation or replacement allowing
                        the resumption of the performance of the Agreement as soon as possible. However, where it is not
                        possible to resume performance of the Agreement within sixty (60) days of the occurrence of the
                        force majeure event, the Agreement shall be terminated automatically and without compensation
                        from either side, by the party that is first to take action and by registered letter with
                        acknowledgement of receipt to the other party. Notwithstanding the foregoing, a force majeure
                        event may in no case whatsoever excuse or delay the fulfillment of the obligations of a Party in
                        respect of Confidentiality or Intellectual Property Rights.
                    </p>
                    <h2 class="privacy__sub-title">
                        3. Severability, no waiver, invalidity

                    </h2><br>
                    <p class="para">
                        The ToS, together with the Privacy Policy, shall constitute the entire agreement between Users
                        and Magnify Insights concerning the Services.

                    </p>
                    <p class="para">
                        No waiver by Mention of any default or provision hereof shall be deemed a waiver of any
                        subsequent default or provision.
                    </p>
                    <p class="para">
                        If any provision of the ToS is held to be invalid, void or for any reason unenforceable, such
                        provision shall be struck out and shall not affect the validity and enforceability of the
                        remaining provisions.

                    </p>
                    <h2 class="privacy__sub-title">
                        4. Relationship of Parties


                    </h2><br>
                    <p class="para">
                        The ToS are not intended to create a relationship such as a franchise, joint venture, agency, or
                        employment relationship. Neither Party may act in a manner which expresses or implies a
                        relationship other than that of independent contractor, nor bind the other Party.


                    </p>
                    <h2 class="privacy__title">
                        XIV. Governing Law

                    </h2><br>
                    <p class="para">The ToS are governed by Republic of Singapore.
                    </p>
                    <p class="para">The effective date of the ToS is [June, 2017]. To the extent any translated version
                        of the ToS conflicts with the English version, the English version shall prevail.
                    </p>
                    <p class="para">To the extent permitted by applicable law, Singapore Courts shall have exclusive
                        jurisdiction over all disputes arising out of the validity, interpretation, execution and/or
                        breach of the ToS and of the service, regardless of plurality of defendants or indemnification
                        provisions.
                    </p>
                    <p class="para">
                        Still need help? Contact Us (<a style="text-decoration:none;" href="mailto:support@bindez.com">support@bindez.com</a>)
                    </p>
                </v-flex>
            </v-layout>
        </v-container>
<!--    </v-app>-->
</template>

<script>
	export default {
		name: "TermsOfService",
	}
</script>

<style scoped>
    @import '../../public/css/bootstrap.min.css';
    @import '../../public/css/bindez.css';
    @import '../../public/css/bindez-custom2.css';

    @font-face {
        font-family: 'icomoon';
        src: url('../../public/fonts/icomoon.eot');
        src: url('../../public/fonts/icomoon.eot') format('embedded-opentype'),
        url('../../public/fonts/icomoon.ttf') format('truetype'),
        url('../../public/fonts/icomoon.woff') format('woff'),
        url('../../public/fonts/icomoon.svg') format('svg');
        font-weight: normal;
        font-style: normal;
    }

    [class^="icon-"],
    [class*=" icon-"] {
        /* use !important to prevent issues with browser extensions that change fonts */
        font-family: 'icomoon' !important;
        speak: none;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;

        /* Better Font Rendering =========== */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .icon-burmese:before {
        content: "\e900";
    }

    .icon-data:before {
        content: "\e901";
    }

    .icon-real-time:before {
        content: "\e902";
    }

    #lp-container {
        background-color: #fff;
    }

    .custom-modal-size > * > * {
        height: 500px;
    }

    p.para {
        font-weight: 400;
        font-size: 20px;
        line-height: 1.8;
        margin-bottom: 16px;
    }

    a {
        text-decoration: none;
    }

    /*h2{*/
    /*    font-weight: 900;*/
    /*    font-size: 25px;*/
    /*    color: #000;*/
    /*}*/

    h1{
        margin-top: 80px;
        font-size: 28px;
        color: #000;
        /*line-height: 1.5;*/
    }

    h2.privacy__title {
        font-weight: 900;
        font-size: 25px;
        margin-bottom: 0;
        color: #000;
    }

    h2.privacy__sub-title {
        font-weight: 900;
        font-size: 23px;
        margin-bottom: 0;
        color: #000;
    }

    h3{
        color: #000;
        font-size: 16.38px;
        line-height: normal;
        font-weight: 900;
    }

    .fact-list--style {
        font-weight: 400;
        font-size: 20px;
    }

    .fact-list--style > li {
        line-height: 1.8;
    }




</style>
